import { useDispatch } from 'react-redux';
import {
	Col,
	CardBody,
	Card,
	Row,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import AddEditWRPositionModal from './Add_Edit/AddEditWRPosition';
import DeleteWRPositionModal from './Delete/DeleteWRPosition';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import { getWaterRightPositionListQuery } from '../../../../slices/waterRightPosition/thunk';
import { Icons } from '../../../../utils/Icons';

const WRPositionList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const [dataWRPosition, setDataWRPosition] = useState({});
	const [refetch, setRefetch] = useState(0);

	const toggleRefetch = () => {
		setRefetch(prev => prev + 1);
	};
	const [isEdit, setIsEdit] = useState(false);

	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);

	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) setActiveTab(tab);
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	const handleClickDelete = data => {
		setDataWRPosition(data);
		setModalDelete(true);
	};

	const handleClickEdit = data => {
		setDataWRPosition(data);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones',
				enableSorting: false,
				enableColumnFilter: false,
				enableGlobalFilter: false,
				enableColumnActions: false,
				accessorKey: 'wrPositions',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex justify-content-center'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const dataData = cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(dataData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const dataData = cellProps.row.original;
													handleClickDelete(dataData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Nombre',
				accessorKey: 'name',
				size: 'auto',
			},
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						<CardBody>
							<ODataGrid
								columns={columns}
								getDataFunc={getWaterRightPositionListQuery}
								baseFilters={{
									disable: { $eq: false },
								}}
								remoteOperations={{
									pagination: true,
									sorting: true,
									filtering: true,
								}}
								refetchRemoteData={refetch}
								nameFile={'posiciones'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataWRPosition({});
											handleToggleModal();
										},
										title: 'Crear Posición',
									},
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditWRPositionModal
				dataWRPosition={dataWRPosition}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
			<DeleteWRPositionModal
				dataWRPosition={dataWRPosition}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
				toggleRefetch={toggleRefetch}
			/>
		</React.Fragment>
	);
};

export default WRPositionList;
